"use strict";
/*
 * Created on 10 04 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var CompanyVsCRPChangeIndexConverter_1 = require("./conversions/CompanyVsCRPChangeIndexConverter");

var CompanyVsCRPChangeIndexConverterImpl_1 = require("./conversions/CompanyVsCRPChangeIndexConverterImpl");

var CompetitorReferentialPriceConverter_1 = require("./conversions/CompetitorReferentialPriceConverter");

var CompetitorReferentialPriceConverterImpl_1 = require("./conversions/CompetitorReferentialPriceConverterImpl");

var ModifiedCompetitorPriceDTOConverter_1 = require("./conversions/ModifiedCompetitorPriceDTOConverter");

var ModifiedCompetitorPriceDTOConverterImpl_1 = require("./conversions/ModifiedCompetitorPriceDTOConverterImpl");

var ReferencePriceConverter_1 = require("./conversions/ReferencePriceConverter");

var ReferencePriceConverterImpl_1 = require("./conversions/ReferencePriceConverterImpl");
/**
 * @author Jaroslav Sevcik
 */


var PriceCalculationAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(PriceCalculationAppModule, _AppModule_1$AppModul);

  function PriceCalculationAppModule() {
    var _this;

    _classCallCheck(this, PriceCalculationAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceCalculationAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'cleaning';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceCalculationAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(CompetitorReferentialPriceConverter_1.CompetitorReferentialPriceConverter).to(CompetitorReferentialPriceConverterImpl_1.CompetitorReferentialPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompanyVsCRPChangeIndexConverter_1.CompanyVsCRPChangeIndexConverter).to(CompanyVsCRPChangeIndexConverterImpl_1.CompanyVsCRPChangeIndexConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReferencePriceConverter_1.ReferencePriceConverter).to(ReferencePriceConverterImpl_1.ReferencePriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ModifiedCompetitorPriceDTOConverter_1.ModifiedCompetitorPriceDTOConverter).to(ModifiedCompetitorPriceDTOConverterImpl_1.ModifiedCompetitorPriceDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return PriceCalculationAppModule;
}(AppModule_1.AppModule);

exports.PriceCalculationAppModule = PriceCalculationAppModule;